exports.default = {
  title: 'Olymp Casino',
  shortTitle: 'Olymp',
  preloaderBg: '#030534',
  preloaderBg2: 'olymp_test_var',
  tokenKey: 'cas-tkn',
  bgColor: '#030534',
  themeColor: '#0b154b',
  tileColor: '#2d89ef',
  platformSite: 'olymp.casino',
  preloaderIcon: 'img/logo_preloader.svg',
  mainDomain: 'olymp.casino',
  licenseInit: null,
  licenseInitTagHtml: null,
}
